/**
 * Legend explaining node types and edge semantics (solid = observed from an
 * API record, dashed = derived/inferred with confidence indicator).
 */
import { FC } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { NODE_TYPE_META } from './nodeStyles';
import { IntelNodeType } from '../../types/intelligenceGraph';

const LEGEND_ORDER: IntelNodeType[] = [
  'organization',
  'pla',
  'person',
  'research',
  'technology',
  'procurement',
  'buyer',
  'supplier',
  'agency',
  'email',
  'domain',
];

export const GraphLegend: FC = () => (
  <Paper
    elevation={2}
    sx={{ px: 1.5, py: 1, borderRadius: 2, maxWidth: 220, opacity: 0.94 }}
  >
    <Typography variant="caption" fontWeight={700} color="text.secondary">
      LEGEND
    </Typography>
    <Stack spacing={0.25} sx={{ mt: 0.5 }}>
      {LEGEND_ORDER.map((type) => {
        const meta = NODE_TYPE_META[type];
        return (
          <Stack key={type} direction="row" spacing={1} alignItems="center">
            <Icon icon={meta.icon} color={meta.color} width={13} />
            <Typography variant="caption">{meta.label}</Typography>
          </Stack>
        );
      })}
    </Stack>
    <Stack spacing={0.25} sx={{ mt: 1 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box sx={{ width: 22, borderTop: '2px solid #94a3b8' }} />
        <Typography variant="caption">Observed (API record)</Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box sx={{ width: 22, borderTop: '2px dashed #94a3b8' }} />
        <Typography variant="caption">Derived / inferred</Typography>
      </Stack>
    </Stack>
  </Paper>
);
